import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { EmpresasModel, EmpresasSearchResponse } from 'src/app/pages/configuracion/maestros/empresas/models/empresas-model';
import { environment } from 'src/environments/environment';
import { IRecuperarEmpresasService } from './ports/i-recuperar-empresas-service';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { FiltroBasico } from 'src/app/shared/models/filtros';



@Injectable({
  providedIn: 'root'
})
export class RecuperaEmpresasMockService implements IRecuperarEmpresasService{

  empresas:EmpresasModel[];

  constructor(private http: HttpClient) { }

  guardaEmpresa(data: EmpresasModel): Observable<void> {
    throw new Error('Method not implemented.');
  }

  getEmpresas(filtros: FiltroBasico[], pageNumber:number, orden?: OrdenColumna): Observable<EmpresasModel[]> {
    const headers = new HttpHeaders()
    .set('content-type', 'application/json')
    let url;
    if(pageNumber == 0){ url = environment.ApiEmpresasMock1; }
    if(pageNumber == 1){ url = environment.ApiEmpresasMock1; }
    if(pageNumber == 2){ url = environment.ApiEmpresasMock2; }

    return this.http.get<EmpresasModel[]>(url, {headers})
      .pipe(
        map(resp => {
          this.empresas= resp;
            return this.empresas;
          }
        )
    );
  }

  deleteEmpresa(data: EmpresasModel): Observable<void> {
    throw new Error('Method not implemented.');
  }

}
